/* KS search outcome tracking.
 *
 * Fires one event per search-results page view (first page only):
 *
 *   ks_search_result
 *     ks_search_term   — the query, whitespace-collapsed, max 100 chars
 *     ks_search_status — hit | fallback | zero
 *     ks_search_count  — number of product cards the visitor ends up seeing
 *
 * Why a status instead of a zero-only event: the zero rate needs a
 * denominator. One event per search keeps numerator and denominator in the
 * same report, so consent gating or a pixel change can never skew the ratio.
 *
 * Status meanings:
 *   hit      — native storefront search returned results
 *   fallback — native returned nothing and ks-search-fallback.js rescued the
 *              query through predictive search (the CJK substring path).
 *              A rising fallback rate means native search is failing more,
 *              even though visitors still see products.
 *   zero     — native AND fallback both came back empty: a real dead end.
 *
 * Same three sinks and the same never-throw contract as ks-nav-tracking.js.
 */
(function () {
  if (window.__ksSearchTracking) return;
  window.__ksSearchTracking = true;

  var FALLBACK_TIMEOUT_MS = 4000;

  function track(name, params) {
    var payload = params || {};

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_e) { /* tracking must never break the page */ }

    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
      }
    } catch (_e) { /* noop */ }

    try {
      window.dataLayer = window.dataLayer || [];
      var entry = { event: name };
      for (var key in payload) entry[key] = payload[key];
      window.dataLayer.push(entry);
    } catch (_e) { /* noop */ }
  }

  function queryParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (_e) {
      return '';
    }
  }

  function itemCount(loop) {
    try {
      return loop.querySelectorAll('.grid-item').length;
    } catch (_e) {
      return 0;
    }
  }

  var reported = false;

  function report(loop, status) {
    if (reported) return;
    reported = true;

    var term = loop.getAttribute('data-ks-search-term') || queryParam('q') || '';
    term = term.replace(/\s+/g, ' ').trim().slice(0, 100);
    if (!term) return;

    track('ks_search_result', {
      ks_search_term: term,
      ks_search_status: status,
      ks_search_count: itemCount(loop)
    });
  }

  try {
    var loop = document.getElementById('SearchLoop');
    if (!loop) return;

    // Only the first page of results — later pages are the same search.
    var page = queryParam('page');
    if (page && page !== '1') return;

    if (loop.getAttribute('data-ks-search-empty') !== 'true') {
      report(loop, 'hit');
      return;
    }

    // Native search came back empty: wait for the CJK fallback to settle
    // before deciding whether this was a rescue or a real dead end.
    var settle = function () {
      report(loop, itemCount(loop) > 0 ? 'fallback' : 'zero');
    };

    document.addEventListener('ks:search-fallback', settle);
    // The fallback script may be absent, bail early, or hang on a slow network.
    setTimeout(settle, FALLBACK_TIMEOUT_MS);
  } catch (_e) { /* noop */ }
})();
